import JSONAPIAdapter from '@ember-data/adapter/json-api';

import { service } from '@ember/service';
import { NotFoundError } from '@ember-data/adapter/error';

import { cacheKeyFor, fetchWithCache } from 'rise-ui/utils/fastboot.js';

/**
 * Base adapter for all ember-data requests in the app
 */
export default class RiseApiAdapter extends JSONAPIAdapter {
  @service ssr;

  pathForType(type) {
    return type;
  }

  cacheKeyFor([ , model, id ]) {
    return cacheKeyFor(model?.modelName, id);
  }

  // Delegate findRecord through queryRecord to avoid 404->200 security requirement
  _findRecordByQueryRecord(store, type, id, { backgroundReload, include, adapterOptions } = {}, key = 'id') {
    return this.queryRecord(store, type, { include, [key]: id }, { adapterOptions, backgroundReload })
      .then(response => {
        if (!response?.data?.length) {
          throw new NotFoundError();
        }
        response.data = response.data[0];
        return response;
      });
  }

  /**
   * Caches fastboot queries to shoebox to avoid extraneous initial client requests
   * @param {function} fetchFn Function like findRecord
   * @param {*[]} args findRecord args
   * @returns {Promise<*>}
   */
  _fetchWithCache(fetchFn, args) {
    if (this.isDestroyed) {
      return Promise.reject('findBelongsTo:isDestroyed');
    }
    const [ , { modelName }, id ] = args;
    return fetchWithCache(modelName, this.ssr,
      () => fetchFn(...args), { id },
    );
  }

  findRecord(...args) {
    return this._fetchWithCache(this._findRecordByQueryRecord.bind(this), args);
  }

  async ajax(url, method, options) {
    let response;
    try {
      response = await super.ajax(...arguments);
    } catch (e) {
      console.error('Request failed:', method, url, options);
      throw e;
    }
    return response;
  }
}
